import * as actionTypes from "./actionTypes";

const initialState = {
  allBots: [],
  currentBot: {},
  editedCurrentBot: {},
  totalIndex: null,
  filter: null,
  getBotsFailed : false
};

const botStorereducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.saveBotsActionType:
      if (action.payload.botIndex == 0){
        return {
          ...state,
          allBots: [...action.payload.data.allBots],
          totalIndex: action.payload.data.totalIndex,
          filter: action.payload.filter,
        };
      }
      else {
        return {
        ...state,
        allBots: [...state.allBots, ...action.payload.data.allBots],
        totalIndex: action.payload.data.totalIndex,
        filter: action.payload.filter,
      };
      }

    case actionTypes.saveCurrentBotActionType:
   
     console.log("in reducer", action.payload)
      return {
        ...state,
        currentBot: action.payload
      };

    case actionTypes.editCurrentBotActionType:
      return {
        ...state,
        editedCurrentBot: { ...state.editedCurrentBot, [action.payload.botID]: {...action.payload} },
      };

    case actionTypes.getBotsFailed:
      return {
        ...state, 
        getBotsFailed : !state.getBotsFailed

      }  
    default:
      return state;
  }
};

export default botStorereducer;
